import { ElementType, PropsWithChildren } from 'react';

const stopPropagation = (e: MouseEvent) => e.stopPropagation();
const StopPropagation = ({
    children,
    Component = 'div',
    ...componentProps
}: PropsWithChildren<{ Component?: ElementType }>) => (
    <Component
        onClick={stopPropagation}
        onMouseDown={stopPropagation}
        onFocus={stopPropagation}
        onMouseEnter={stopPropagation}
        onMouseLeave={stopPropagation}
        {...componentProps}
    >
        {children}
    </Component>
);

export default StopPropagation;
